import { IonImg } from "@ionic/react";
import React from "react";

export const CompanyLinkLogo: React.FC<React.ComponentProps<typeof IonImg>> = props => (
  <a href="https://tilalogistics.ca/" target="_blank" rel="noopener noreferrer">
    <IonImg src={require("../../../../assets/logo.png")} className={props.className} alt="Logo" />
  </a>
);